import { useState } from "react";
import {
  Box,
  IconButton,
  Link,
  Popover,
  Tooltip,
  Typography,
} from "@material-ui/core";
import DescriptionIcon from "@material-ui/icons/Description";

import { ContainmentPad } from "../../interface/api/ContainmentPad";
import { ContainmentPadSample } from "../../interface/api/ContainmentPadSample";
import storageAreaService from "../../services/storageAreaService";
import { history } from "../..";
import { formatDateTime } from "../../utils/date-helper";

const ContainmentPadCell = ({ pad }: { pad?: ContainmentPad }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [sample, setSample] = useState<ContainmentPadSample | null>(null);
  const [loading, setLoading] = useState(false);

  if (!pad) {
    return <span>—</span>;
  }

  const isClosed = pad.status === "Closed";

  const onOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
    setLoading(true);
    storageAreaService.getContainmentPadSample(pad.id).then((response) => {
      if (response.ok && response.data) {
        setSample(response.data as ContainmentPadSample);
      }
      setLoading(false);
    });
  };

  const onClose = () => setAnchorEl(null);

  const goToScreen = () =>
    history.push(`/containment-pad-sampling/${pad.id}`);

  if (!isClosed) {
    return (
      <Link
        component="button"
        type="button"
        onClick={goToScreen}
        style={{ textAlign: "left" }}
      >
        {pad.name}
      </Link>
    );
  }

  return (
    <Box display="flex" alignItems="center" style={{ gap: 4 }}>
      <Box display="flex" flexDirection="column">
        <Link
          component="button"
          type="button"
          onClick={goToScreen}
          style={{ fontWeight: 600, textAlign: "left" }}
        >
          {pad.name}
        </Link>
        {pad.approvalDate && (
          <Typography variant="caption" color="textSecondary">
            Approved {formatDateTime(pad.approvalDate, true)}
          </Typography>
        )}
      </Box>
      <Tooltip title="View sample & lab result">
        <IconButton size="small" color="primary" onClick={onOpen}>
          <DescriptionIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} style={{ minWidth: 240 }}>
          <Typography variant="subtitle2" gutterBottom>
            Sample — {pad.name}
          </Typography>
          {loading && <Typography variant="body2">Loading…</Typography>}
          {!loading && sample && (
            <Box display="flex" flexDirection="column" style={{ gap: 6 }}>
              <Typography variant="body2">
                Sample Reference #: {sample.sampleReferenceNumber || "—"}
              </Typography>
              {sample.labResultUrl ? (
                <Link
                  href={sample.labResultUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View lab result
                </Link>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No lab result
                </Typography>
              )}
            </Box>
          )}
        </Box>
      </Popover>
    </Box>
  );
};

export default ContainmentPadCell;
